var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.error && _vm.content.body && _vm.content.title)?_c('article',[_c('section',{domProps:{"innerHTML":_vm._s(_vm.content.body)}})]):(_vm.error)?_c('article',[_c('h3',[_vm._v("Er ging iets mis bij het ophalen van de gegevens..")])]):_c('article',[_c('h3',[_vm._v("Geen inhoud.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }